
import axios from 'axios';
import { BASE_URL, BASE_URL_LOGIN } from './ip';

export const FETCH_QUESTIONS_SUCCESS = "FETCH_QUESTIONS_SUCCESS";
export const FETCH_QUESTIONS_ERROR = "FETCH_QUESTIONS_ERROR";

export const FETCH_CLINICS_SUCCESS = "FETCH_QUESTIONS_SUCCESS";
export const   FETCH_CLINICS_FAILURE= "FETCH_CLINICS_FAILURE";

export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
export const SUBMIT_FORM_ERROR = 'SUBMIT_FORM_ERROR';
export const SUBMIT_FORM_LOADING = 'SUBMIT_FORM_LOADING';

export const fetchQuestionsSuccess = (questions) => ({
  type: FETCH_QUESTIONS_SUCCESS,
  payload: questions,
});

export const fetchQuestionsError = (error) => ({
  type: FETCH_QUESTIONS_ERROR,
  payload: error,
});

export const fetchQuestions = () => {
  return (dispatch) => {
    axios
      .get(`${BASE_URL_LOGIN}/BMIQuiz/bmiquizquestions`)
      .then((response) => {
        dispatch(fetchQuestionsSuccess(response.data)); 
      })
      .catch((error) => {
        dispatch(fetchQuestionsError(error.message || 'An error occurred'));
      });
  };
};


export const fetchClinics = () => async (dispatch) => {
  try {
    const response = await fetch(`${BASE_URL_LOGIN}/BMIQuiz/bmiquizclinics`);
    const data = await response.json();
    dispatch({ type: "FETCH_CLINICS_SUCCESS", payload: data });
  } catch (error) {
    console.error("Error fetching clinics:", error);
  }
};



export const submitFormSuccess = (data) => ({
  type: SUBMIT_FORM_SUCCESS,
  payload: data,
});

export const submitFormError = (error) => ({
  type: SUBMIT_FORM_ERROR,
  payload: error,
});

export const submitFormLoading = () => ({
  type: SUBMIT_FORM_LOADING,
});

export const submitFormData = (formData) => async (dispatch) => {
  try {
    const heightInInches = (parseFloat(formData.heightFeet) * 12) + parseFloat(formData.heightInches);

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      birthDate: formData.dateOfBirth,
      clinicId: formData.clinicName,
      height: heightInInches,
      weight: parseFloat(formData.weight),
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      bmi: parseFloat(
        (formData.weight / (heightInInches * heightInInches) * 703
      ).toFixed(2)),
      isAuthorized: formData.authorization,
      otherClinicName: formData.otherClinicName,
      acceptTerms: formData.acceptTerms,
    };

  
    dispatch(submitFormLoading());

    const response = await axios.post(`${BASE_URL_LOGIN}/BMIQuiz/save`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    dispatch(submitFormSuccess(response.data));
  } catch (error) {
    if (error.response) {
      dispatch(submitFormError(`HTTP ${error.response.status}: ${error.response.data}`));
    } else if (error.request) {
      dispatch(submitFormError('No response received from server'));
    } else {
      dispatch(submitFormError(error.message || 'An error occurred'));
    }
  }
};
